import AutoSlider from './../components/AutoSlider'

export default () => {

  const featuresCarousel = new AutoSlider('#features-section .features__carousel');
  featuresCarousel.init()

}
